export default __webpack_public_path__ + "static/media/coin98.5e29f47c.svg";